<template>
    <div class="maintenance-warning">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        props: {
            address: {
                type: Object,
                required: true,
            }
        }
    }
</script>
<style>
    /** Enable this CSS when using the global warning again */
    /*.maintenance-warning {*/
        /*height: 30px;*/
        /*width: 100%;*/
        /*top: 0;*/
        /*left: 0;*/
        /*position: fixed;*/
        /*text-align: center;*/
        /*background-color: tomato;*/
        /*display: flex;*/
        /*justify-content: center;*/
        /*align-items: center;*/
    /*}*/
    /*.maintenance-warning {*/
        /*color: #fff;*/
    /*}*/

    /*!***/
     /** Override global styles to make place for warning*/
     /**!*/
    /*#app {*/
        /*position: relative;*/
        /*top: 30px;*/
    /*}*/
    /*header.header.fixed-top {*/
        /*top: 30px;*/
    /*}*/
</style>
